import { apiCall, API_CONFIG } from './api';

export const driversAPI = {
  getDriversList: async ({ page = 1, limit = 20, search } = {}) => {
    try {
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      if (search) queryParams.set('search', search);

      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.DRIVERS}?${queryParams.toString()}`,
        { method: 'GET' }
      );

      if (response.success) {
        return {
          success: true,
          data: response.data?.drivers || [],
          pagination: response.data?.pagination,
          msg: response.msg,
        };
      }

      return {
        success: false,
        error: response.message || response.msg || 'Failed to fetch drivers',
      };
    } catch (error) {
      console.error('List drivers error:', error);
      return { success: false, error: 'Network error. Please try again.' };
    }
  },

  createDriver: async (payload) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.DRIVERS, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (response.success) {
        return { success: true, data: response.data, msg: response.msg };
      }

      return {
        success: false,
        error: response.message || response.msg || 'Failed to create driver',
      };
    } catch (error) {
      console.error('Create driver error:', error);
      return { success: false, error: 'Network error. Please try again.' };
    }
  },

  updateDriver: async (driverId, payload) => {
    try {
      const hasFile = payload.profilePictureFile instanceof File;
      let requestBody;

      if (!hasFile) {
        requestBody = { ...payload };
        delete requestBody.profilePictureFile;
        delete requestBody.profilePicture;
      } else {
        requestBody = new FormData();
        Object.keys(payload).forEach((key) => {
          if (key === 'profilePictureFile') {
            requestBody.append('profilePicture', payload[key]);
          } else if (key !== 'profilePicture') {
            requestBody.append(key, payload[key]);
          }
        });
      }

      const response = await apiCall(`${API_CONFIG.ENDPOINTS.DRIVERS}/${driverId}`, {
        method: 'PATCH',
        body: requestBody instanceof FormData ? requestBody : JSON.stringify(requestBody),
      });

      if (response.success) {
        return { success: true, data: response.data, msg: response.msg };
      }

      return {
        success: false,
        error: response.message || response.msg || 'Failed to update driver',
      };
    } catch (error) {
      console.error('Update driver error:', error);
      return { success: false, error: 'Network error. Please try again.' };
    }
  },
};
